import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { forEach } from 'lodash';

import Toolkit from './Toolkit';
import Zoom from './Zoom';
import Annotation from './Annotation';
import FormulaSheet from './FormulaSheet';
import PeriodicTable from './PeriodicTable';
import { getObjectItemByIndex } from '../utility/Utils';

import './SkinWrapper.scss';
import { connect } from 'react-redux';
import { addBookmark, removeBookmark } from 'legacy-src/actions/bookmarks';

/**
 * Wrapper that applies skin logic on top of learnosity player
 * */
class SkinWrapperDesktop extends PureComponent {
  static displayName = 'SkinWrapperDesktop';

  static propTypes = {
    preview: PropTypes.bool,
    onShowModal: PropTypes.func,
    onCloseModal: PropTypes.func,
    annotationData: PropTypes.object,
    learnosityData: PropTypes.object,
    toogleStatus: PropTypes.bool,
    isMetaDataPanelExpanded: PropTypes.bool,
    questionChanged: PropTypes.bool,
    isImpersonating: PropTypes.bool,
  };

  static defaultProps = {
    preview: false,
    annotationData: null,
    learnosityData: {},
    toogleStatus: false,
    isMetaDataPanelExpanded: false,
    questionChanged: false,
    isImpersonating: false,
  };

  constructor(props) {
    super(props);

    this.readyListener = this.readyListener.bind(this);
    this.increaseAsianFontSize = this.increaseAsianFontSize.bind(this);
    this.renderQuestionToolkit = this.renderQuestionToolkit.bind(this);
    this.renderZoomContainer = this.renderZoomContainer.bind(this);
    this.renderFormulaSheet = this.renderFormulaSheet.bind(this);
    this.renderPeriodicTable = this.renderPeriodicTable.bind(this);
    this.resetResources = this.resetResources.bind(this);
    this.unmountDomComponent = this.unmountDomComponent.bind(this);
    this.unmountDomComponents = this.unmountDomComponents.bind(this);
    this.itemLoad = this.itemLoad.bind(this);
    this.itemChanging = this.itemChanging.bind(this);
    this.itemChanged = this.itemChanged.bind(this);

    this.state = {
      formulaSheetOpen: false,
      periodicTableOpen: false,
    };
  }

  componentDidMount() {
    this.readyListener();
  }

  componentDidUpdate(prevProps, prevState) {
    const { questionChanged: oldQuestionChanged, bookmarks: prevBookmarks } =
      prevProps;
    const {
      toogleStatus,
      isMetaDataPanelExpanded,
      questionChanged,
      bookmarks,
    } = this.props;
    const { formulaSheetOpen, periodicTableOpen } = this.state;

    if (questionChanged !== oldQuestionChanged && questionChanged) {
      this.resetResources();
    }

    if (prevProps.toogleStatus !== toogleStatus) {
      const annotationContainer = document.querySelector(
        '.Annotation--container',
      );
      if (annotationContainer) {
        if (toogleStatus) {
          annotationContainer.classList.add('Annotation--container--shift');
          this.toggleAnnotations(true);
        } else if (
          annotationContainer.classList.contains('Annotation--container--shift')
        ) {
          this.toggleAnnotations(false);
          annotationContainer.classList.remove('Annotation--container--shift');
        }
      }
    }

    if (prevBookmarks !== bookmarks) {
      this.renderQuestionToolkit();
    }

    if (
      (prevState.formulaSheetOpen !== formulaSheetOpen &&
        formulaSheetOpen !== undefined) ||
      (prevState.periodicTableOpen !== periodicTableOpen &&
        periodicTableOpen !== undefined) ||
      questionChanged !== oldQuestionChanged
    ) {
      this.renderQuestionToolkit();
    }

    this.onMetaDataPanelUpdate(
      isMetaDataPanelExpanded,
      prevProps.isMetaDataPanelExpanded,
    );
  }

  onMetaDataPanelUpdate = (
    currentIsMetaDataPanelExpanded,
    prevIsMetaDataPanelExpanded,
  ) => {
    const { showGrayTopRightBarPreview, isMobile } = this.props;

    if (currentIsMetaDataPanelExpanded !== prevIsMetaDataPanelExpanded) {
      const toolkit = document.querySelector('.Toolkit');

      const lrnGroupTop =
        showGrayTopRightBarPreview && document.querySelector('.lrn-group-top');
      const lrnZoomContainer =
        showGrayTopRightBarPreview &&
        document.querySelector('.lrn-zoom-container');
      const slidesContainer =
        showGrayTopRightBarPreview &&
        document.querySelector('.slides-container');

      if (currentIsMetaDataPanelExpanded) {
        toolkit && isMobile && toolkit.classList.add('hidden');
        lrnGroupTop && lrnGroupTop.classList.add('Navigation--small');
        lrnZoomContainer &&
          lrnZoomContainer.classList.add('lrn-zoom-container--shift');
        slidesContainer &&
          slidesContainer.classList.remove('slides-container--new');
      } else {
        toolkit && isMobile && toolkit.classList.remove('hidden');
        lrnGroupTop && lrnGroupTop.classList.remove('Navigation--small');
        lrnZoomContainer &&
          lrnZoomContainer.classList.remove('lrn-zoom-container--shift');
        slidesContainer &&
          slidesContainer.classList.add('slides-container--new');
      }
    }
  };

  resetResources() {
    this.toggleFormulaSheet(false);
    this.togglePeriodicTable(false);
    this.unmountDomComponents('.formula-sheet-container');
    this.unmountDomComponents('.periodic-table-container');
    this._formulaSheet = undefined;
    this._periodicTable = undefined;
    this.renderFormulaSheet();
    this.renderPeriodicTable();
  }

  getDOMContainer = (className) => {
    const { fullScreen } = this.props;
    const mainContainer = fullScreen
      ? document.querySelector('body')
      : document.querySelector('.PlayerModeContainer--content');
    const containerNode = document.createElement('div');
    containerNode.className = `lrn-custom-container ${className}`;

    mainContainer.appendChild(containerNode);
    return containerNode;
  };

  /**
   * Renders the zoom container
   * */
  renderZoomContainer() {
    const containerNode = this.getDOMContainer('lrn-zoom-container');
    const {
      learnosityData: { app },
    } = this.props;

    const content = <Zoom app={app} />;
    ReactDOM.render(content, containerNode);
  }

  /**
   * Renders the annotation tool
   * */
  renderAnnotationTool = () => {
    if (!this._annotationTool) {
      const {
        learnosityData: { app },
        onShowModal,
        annotationData,
        isImpersonating,
      } = this.props;

      const containerNode = this.getDOMContainer('lrn-annotation-container');
      const content = (
        <Annotation
          isMobile={false}
          app={app}
          showModal={onShowModal}
          annotationData={annotationData}
          isImpersonating={isImpersonating}
        />
      );
      const that = this;
      ReactDOM.render(content, containerNode, function _renderAnnotationTool() {
        that._annotationTool = this;
      });
    }
  };

  renderResource = (resourceProp, resourceContainer, ResourceComponent) => {
    if (!this[resourceProp]) {
      const mainContainer = document.querySelector(
        '.PlayerModeContainer--content',
      );
      const container = document.createElement('div');
      container.className = resourceContainer;
      mainContainer.insertBefore(container, mainContainer.firstChild);

      const sheetContainer = document.querySelector(`.${resourceContainer}`);

      ReactDOM.render(ResourceComponent, sheetContainer, () => {
        this[resourceProp] = this;
      });
    }
  };

  renderFormulaSheet = () => {
    const resourceProp = '_formulaSheet';
    if (!this[resourceProp]) {
      const { formulaSheet } = this.props;
      if (formulaSheet) {
        this.renderResource(
          resourceProp,
          'formula-sheet-container',
          <FormulaSheet
            formulaSheet={formulaSheet}
            onCloseClick={() => this.toggleFormulaSheet(false)}
          />,
        );
      }
    }
  };

  renderPeriodicTable = () => {
    const resourceProp = '_periodicTable';
    if (!this[resourceProp]) {
      const { periodicTable } = this.props;
      if (periodicTable) {
        this.renderResource(
          resourceProp,
          'periodic-table-container',
          <PeriodicTable
            periodicTable={periodicTable}
            onCloseClick={() => this.togglePeriodicTable(false)}
          />,
        );
      }
    }
  };

  componentWillUnmount() {
    this.unmountDomComponent('.top-right-wrapper .top-questions-overview');
    this.unmountDomComponent('.lrn-items-region .question-info');
    this.unmountDomComponent('.right-wrapper .right-wrapper');
    this.unmountDomComponents('.lrn-zoom-container');
    this.unmountDomComponents('.lrn-annotation-container');
    this.unmountDomComponents('.tabbed-passages');
    this.unmountDomComponents('.formula-sheet-container');
    this.unmountDomComponents('.periodic-table-container');
  }

  /**
   * Unmounts component from dom
   * @param {string} selector The query selector
   * */
  unmountDomComponent(selector) {
    const element = document.querySelector(selector);
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
      element.parentElement.removeChild(element);
    }
  }

  /**
   * Unmounts components from dom
   * @param {string} selector The query selector
   * */
  unmountDomComponents(selector) {
    const elements = document.querySelectorAll(selector);

    forEach(elements, (element) => {
      ReactDOM.unmountComponentAtNode(element);
      element.parentElement.removeChild(element);
    });
  }

  /**
   * Event handler for when item has loaded
   * @note initial render of the item is not triggering the event
   * */
  itemLoad() {
    //this.redrawQuestionDetails();
    const {
      learnosityData: { app },
      onHighlight,
      isMobile,
      preview,
    } = this.props;
    const item = app.getCurrentItem();
    this.setHasLayoutOverride(item);

    if (preview) {
      // Positioning for the second next button is a little off for preap subjects previews
      // This adds a class so that we can adjust as needed
      const nextItemButton = document.querySelector(
        '.slides-container .item-next.pos-right',
      );
      nextItemButton && nextItemButton.classList.add('pos-right--right');
    }

    if (!isMobile) {
      // Removing this class wrongly added by the learnosity widget in the desktop experience
      // It gets auto removed if we resize the window, but we need it not to be present from start
      this.container.classList.remove('lrn-layout-single-column');
    }

    onHighlight(item.reference); // Shared passage text highlighting
  }

  /**
   * Event handler before items has loaded
   * @param {number} itemIndex
   * */
  itemChanging(itemIndex) {
    const {
      learnosityData: { items },
    } = this.props;

    const item = getObjectItemByIndex(items, itemIndex);
    if (item) {
      this.setHasLayoutOverride(item);
    }
  }

  /**
   * Event handler after item has loaded
   * */
  itemChanged() {
    this.increaseAsianFontSize();
  }

  /**
   * Applies classes to the container based on several factors:
   * 1. Does the item have a "Layout Override" tag? If so, then add
   *    a '.layout-override-{tag value}'
   * 2. Does the rendered item not generate a '.lrn-overview' element?
   *    If so, then add 'without-overview-layout' to it.
   *
   * These can be (and, in the case of PRE-AP, _are_) used to change the way the elements
   * are displayed using CSS.
   *
   * @param {object} item Current learnosity item
   * NOTE: This implementation is generic, but as of 2019-04-19 is only in use by PREAP.
   */
  setHasLayoutOverride(item) {
    if (item) {
      const layoutType = this.getLayoutOverride(item);
      const { reference } = item;
      const withoutOverview =
        this.container.querySelector(
          `[data-reference="${reference}"] .lrn-overview`,
        ) === null;
      if (withoutOverview) {
        this.container.classList.add('without-overview-layout');
      } else {
        this.container.classList.remove('without-overview-layout');
      }

      if (layoutType) {
        this.container.classList.add(`layout-override-${layoutType}`);
      } else {
        forEach(this.container.classList, (className) => {
          if (className.startsWith('layout-override')) {
            this.container.classList.remove(className);
          }
        });
      }
    }
  }

  /**
   * Looks at the tags for the provided item and checks for the 'Layout Override'.
   * If it is present returns the value of that tag. e.g. "stack"
   *
   * @param {object} item Current learnosity item
   * @return {string}
   */
  getLayoutOverride(item) {
    // PREAP-1318: If this item has a layout override tag, then set that
    // somewhere so we can access it in other parts of the app and css
    const {
      learnosityData: { app },
    } = this.props;
    const itemTags = app.getTags()[item.source.reference] || [];
    let layoutTag = null;
    if (itemTags) {
      itemTags.forEach((tag) => {
        if (tag.toString().indexOf('Layout Override') === 0) {
          layoutTag = tag.split(':')[1];
        }
      });
    }
    return layoutTag;
  }

  /**
   * Control visibility of the annotation tool
   * */
  toggleAnnotations = (value) => {
    if (this._annotationTool) {
      this._annotationTool.setVisibility(value);
      const action = value ? 'add' : 'remove';
      const lrnQuestions = document.querySelectorAll('.lrn_question');
      forEach(lrnQuestions, (question) =>
        question.classList[action]('annotation--enabled'),
      );
    }
  };

  bringToTop = (container) => {
    const oldOnTopBox = document.getElementById(
      'draggable-box-container-on-top',
    );
    if (oldOnTopBox) {
      oldOnTopBox.classList.remove('--on-top');
      oldOnTopBox.setAttribute('id', '');
    }

    const newOnTopBox = container.querySelector('.draggable-box-container');

    if (newOnTopBox) {
      newOnTopBox.classList.add('--on-top');
      newOnTopBox.setAttribute('id', 'draggable-box-container-on-top');
    }
  };

  /**
   * Control visibility of the formula sheet
   * */
  toggleFormulaSheet = (value) => {
    if (this._formulaSheet) {
      const action = value ? 'add' : 'remove';

      const formulaSheetContainer = document.querySelector(
        '.formula-sheet-container',
      );

      if (value) {
        this.bringToTop(formulaSheetContainer);
      }

      formulaSheetContainer.classList[action]('--enabled');
      this.setState({
        formulaSheetOpen: !!value,
      });
    }
  };

  /**
   * Control visibility of the periodic table
   * */
  togglePeriodicTable = (value) => {
    if (this._periodicTable) {
      const action = value ? 'add' : 'remove';
      const periodicTableontainer = document.querySelector(
        '.periodic-table-container',
      );

      if (value) {
        this.bringToTop(periodicTableontainer);
      }

      periodicTableontainer.classList[action]('--enabled');
      this.setState({
        periodicTableOpen: !!value,
      });
    }
  };

  /**
   * Method for checking for asian characters and add a class for bigger font size to element.
   * */
  increaseAsianFontSize() {
    const increasedFontClass = 'lrn_increased_font';
    const playerContainer = document.querySelector('.Player');
    const headings = playerContainer.querySelectorAll('h1, h2, h3, h4, h5, h6');
    const paragraphs = playerContainer.querySelectorAll('p');

    const possibleAsianElements = [...headings, ...paragraphs];

    forEach(possibleAsianElements, (possibleAsianElement) => {
      const match = possibleAsianElement.textContent.match(/[\u3400-\u9FBF]/);

      if (match) {
        possibleAsianElement.classList.add(increasedFontClass);
      } else if (possibleAsianElement.classList.contains(increasedFontClass)) {
        possibleAsianElement.classList.remove(increasedFontClass);
      }
    });
  }

  /**
   * Init method
   * */
  readyListener() {
    const {
      learnosityData: { app },
      annotationData,
      showLargeFont,
      formulaSheet,
      periodicTable,
    } = this.props;

    this.container = document.querySelector('.lrn');

    app.on('item:load', this.itemLoad);
    app.on('item:changing', this.itemChanging);
    app.on('item:changed', this.itemChanged);

    this.renderQuestionToolkit();
    //this.redrawQuestionDetails();
    if (annotationData) {
      this.renderAnnotationTool();
    }

    if (showLargeFont) {
      this.increaseAsianFontSize();
    }

    if (!!formulaSheet) {
      this.renderFormulaSheet();
    }

    if (!!periodicTable) {
      this.renderPeriodicTable();
    }
  }

  /**
   * Render a customizable toolkit panel,
   * by replacing the Learnosity Toolkit Panel
   */
  renderQuestionToolkit() {
    const {
      learnosityData: { app },
      onShowModal,
      onCloseModal,
      annotationData,
      allowCalculatorForItems,
      showCalculatorAllowedIcon,
      isPreApSubject,
      formulaSheet,
      periodicTable,
      questionChanged,
      showQuestionBookmark,
      bookmarks,
      addBookmark,
      removeBookmark,
      playerContainerId,
    } = this.props;
    const playerContainer = document.querySelector(`#${playerContainerId}`);
    const rightContainer = document.querySelector('.right-wrapper');

    const toolkitRendered = !!document.querySelector('.Toolkit');

    if (!toolkitRendered) {
      rightContainer.innerHTML = '';
    }

    ReactDOM.render(
      <Toolkit
        isPreApSubject={isPreApSubject}
        app={app}
        learnosityData={this.props.learnosityData}
        onShowModal={onShowModal}
        onCloseModal={onCloseModal}
        showAnnotationIcon={!!annotationData}
        showFormulaSheetIcon={!!formulaSheet}
        showPeriodicTableIcon={!!periodicTable}
        showQuestionBookmark={showQuestionBookmark}
        toggleAnnotations={this.toggleAnnotations}
        toggleFormulaSheet={this.toggleFormulaSheet}
        togglePeriodicTable={this.togglePeriodicTable}
        formulaSheetOpen={this.state.formulaSheetOpen}
        periodicTableOpen={this.state.periodicTableOpen}
        allowCalculatorForItems={allowCalculatorForItems}
        showCalculatorAllowedIcon={showCalculatorAllowedIcon}
        questionChanged={questionChanged}
        bookmarks={bookmarks}
        addBookmark={addBookmark}
        removeBookmark={removeBookmark}
        playerContainer={playerContainer}
      />,
      rightContainer,
    );
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  const { bookmarks } = state;

  return {
    bookmarks,
  };
};

const mapDispatchToProps = {
  addBookmark,
  removeBookmark,
};

export default connect(mapStateToProps, mapDispatchToProps)(SkinWrapperDesktop);
